module.exports = __webpack_public_path__ + "img/62.db447c79.jpg";